import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "antd";
import { FormServiceGroupFieldDescription } from "./fields/description.js";
import { FormServiceGroupFieldName } from "./fields/name.js";
import { useFormServiceGroup } from "../../../contexts/formServiceGroup.js";
import { useI18n } from "../../../contexts/i18n.js";
import { ListMultilingualLanguages } from "../../common/listMultilingualLanguages.js";
const FormServiceGroup = ()=>{
    const { __ } = useI18n();
    const { onCancel, recordId, languages, languageOnClick } = useFormServiceGroup();
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            languages?.length > 0 && /*#__PURE__*/ _jsx(Form.Item, {
                label: __("Translations"),
                style: {
                    marginBottom: 12
                },
                children: /*#__PURE__*/ _jsx(ListMultilingualLanguages, {
                    recordId: recordId,
                    languages: languages,
                    onClick: languageOnClick
                })
            }),
            /*#__PURE__*/ _jsx(FormServiceGroupFieldName, {}),
            /*#__PURE__*/ _jsx(FormServiceGroupFieldDescription, {}),
            /*#__PURE__*/ _jsxs(Form.Item, {
                children: [
                    !!onCancel && /*#__PURE__*/ _jsx("button", {
                        className: "button",
                        onClick: (e)=>{
                            e.preventDefault();
                            onCancel();
                        },
                        children: __("Cancel")
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        type: "submit",
                        className: "button button-primary right",
                        value: __("Save")
                    })
                ]
            })
        ]
    });
};
export { FormServiceGroup };
